angular.module("events")
    .controller("EventsIndicatorsListCtrl", ['event', 'LoginService', '$rootScope', '$scope', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$translate', '$stateParams', '$state', 'treeService',
        function (event, LoginService, $rootScope, $scope, Restangular, gridService, modalService, $uibModal, $filter, $translate, $stateParams, $state, treeService) {

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("EVENTS_INDICATOR_WRITE") ;
            if(!Array.isArray($scope.$parent.menusItems)) {
                $state.go("events.edit", { id: $stateParams.id });
            } else {
                let results = $scope.$parent.menusItems.filter(m => m.id === parseInt($stateParams.menu_item_id, 10));
                if(results.length > 0) {
                    $scope.allowWrite &&= results[0].editable;
                } else {
                    $scope.allowWrite = false;
                }
            }

            $rootScope.title = $filter('translate')('events.title') + " - " + $filter('translate')('events.indicators_types.indicators_types');
            $rootScope.breadcrumb = [
                { title: $filter('translate')('events.title'), url: "events.list" },
                { title: $filter('translate')('events.title'), url: "events.list" },
                { title: $filter('translate')('events.indicators_types.indicators_types') }
            ];

            $scope.event_indicator = {};
            $scope.eventIndicators = [];
           // $scope.eventIndicatorsIds = [];
            $scope.search = {};

            $scope.event = event;
            $rootScope.breadcrumb = [
            { title: $filter('translate')('events.title'), url: "events.list" },
            { title: $scope.event.name, url: "events.edit({ id: " + $scope.event.id + " })" },
            { title: $filter('translate')('events.indicators_types.indicators_types') }
            ];
            $rootScope.title = $scope.event.name + " - " + $filter('translate')('events.indicators_types.indicators_types');

            Restangular.all('EventsStaff').getList({ event_id: $scope.event.id }).then(function (staffList) {
                $scope.selectStaff = [];
                angular.forEach(staffList, function (eventStaff, idx) {
                    var aux = eventStaff.FK_events_staff_staff.name;
                    if (eventStaff.FK_events_staff_staff.surname != null) aux += " " + eventStaff.FK_events_staff_staff.surname;
                    if (eventStaff.FK_events_staff_staff.lastname != null) aux += " " + eventStaff.FK_events_staff_staff.lastname;
                    $scope.selectStaff.push({
                        name: aux,
                        id: eventStaff.FK_events_staff_staff.id
                    });
                });
                $scope.selectStaff.unshift({
                    name: $filter('translate')('events.indicators_types.no_person'),
                    id: null
                });
            });

            Restangular.all('IndicatorsTypes').getList().then(function (indicatorsTypes) {
                $scope.selectIndicatorsTypes = indicatorsTypes;
            });

            $scope.loadIndicators = function () {
                Restangular.all('EventsIndicators').getList({ event_id: $stateParams.id }).then(function (results) {
                    $scope.eventIndicators = results;
                    var data = treeService.indicators($scope.eventIndicators);
                    $scope.gridOptionEventIndicators.data = data;
                    /*  angular.forEach($scope.eventIndicators, function (eventIndicator, idx) {
                          $scope.eventIndicatorsIds.push(eventIndicator.indicators_types.id);
                      });*/
                });
            }
            $scope.loadIndicators();
          /*  $scope.filterIndicators = function (value) {
                if (angular.isDefined($scope.eventIndicatorsIds) && $scope.eventIndicatorsIds.indexOf(value.id) == -1) {
                    return true;
                } else {
                    return false;
                }
            }*/

            $scope.gridOptionEventIndicators = {
                enablePaginationControls: false,
                showTreeExpandNoChildren: true,
                columnDefs: [
                  { name: 'FK_events_indicators_indicators_types.id', visible: false, exporterSuppressExport: true },
                  { name: 'name', field: 'FK_events_indicators_staff.name', displayName: $filter('translate')('events.indicators_types.person') },
                  { name: 'indicator_name', field: 'FK_events_indicators_indicators_types.name', displayName: $filter('translate')('events.indicators_types.indicator') },
                  { name: 'value', displayName: $filter('translate')('events.indicators_types.value') },
                  {
                      name: 'date', displayName: $filter('translate')('events.indicators_types.date'), width: 200,
                      type: 'date', cellFilter: 'toLocalDate | date:\'dd/MM/yyyy\''
                  },
                  {
                      name: ' ', width: 100, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                          { title: $filter('translate')('events.indicators_types.delete'), action: 'ng-show="row.entity.date" ng-click="grid.appScope.deleteEventIndicator(row.entity.FK_events_indicators_indicators_types.id);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                      ], { cssClass: "pull-right" })
                  },
                ]
            };


            $scope.addEventIndicator = function () {
                // var index = $scope.eventIndicatorsIds.indexOf($scope.event_indicator.FK_events_indicators_indicators_types.id);
               // if (index == -1) {
                //  $scope.eventIndicatorsIds.push($scope.event_indicator.FK_events_indicators_indicators_types.id);
                let eventIndicator: any = {};
                eventIndicator.event_id = $stateParams.id;
                eventIndicator.staff_id = $scope.event_indicator.FK_events_indicators_staff.id;
                eventIndicator.value = $scope.event_indicator.value;


                eventIndicator.FK_events_indicators_staff = $scope.event_indicator.FK_events_indicators_staff;
                eventIndicator.date = $scope.event_indicator.date;
                eventIndicator.FK_events_indicators_indicators_types = $scope.event_indicator.FK_events_indicators_indicators_types;
                eventIndicator.indicator_type_id = $scope.event_indicator.FK_events_indicators_indicators_types.id;
                $scope.eventIndicators.push(eventIndicator);
                var data = treeService.indicators($scope.eventIndicators);
                $scope.gridOptionEventIndicators.data = data;

               // }

                $scope.event_indicator.FK_events_indicators_indicators_types = "";
                $scope.event_indicator.value = "";
                $scope.event_indicator.staff = "";
                $scope.event_indicator.date = "";
            };

            $scope.deleteEventIndicator = function (id) {
                angular.forEach($scope.eventIndicators, function (eventIndicator, idx) {
                    if (eventIndicator.indicator_type_id == id) {
                        $scope.eventIndicators.splice(idx, 1);
                       // $scope.eventIndicatorsIds.splice(idx, 1);
                        var data = treeService.indicators($scope.eventIndicators);
                        $scope.gridOptionEventIndicators.data = data;
                    }
                });
            }

            $scope.saveEventIndicator = function () {
                $scope.eventIndicatorContainer = {};
                $scope.eventIndicatorContainer.event_id = $stateParams.id;
                $scope.eventIndicatorContainer.events_indicators = $scope.eventIndicators;
                Restangular.all('EventsIndicators').post($scope.eventIndicatorContainer).then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('events.edit_success'));
                        $scope.loadIndicators();
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });
            }
        }])

;
